import React from 'react';
import { useHistory } from "react-router-dom";
import http from '../services/httpService';
import {useStripe, useElements, CardElement} from '@stripe/react-stripe-js';

import CardSection from './cardSection';

const apiEndpoint = 'users'

export default function CheckoutForm({ user }) {
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();

  const handlePaymentMethod = async (result) => {
    if (result.error) {
      // Show error in payment form
    } else {
      // Otherwise send paymentMethod.id to your server
      const data = { payment_method_id: result.paymentMethod.id };
      const config = { headers: {
        'Content-Type': 'application/json'
      }};
      const resp = await http.patch(apiEndpoint + '/' + user.id, data, config);
      console.log(resp);
      // NOTE: Check for success?
      history.push('/');
    }
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
      billing_details: {
        email: user.email,
      },
    });

    await handlePaymentMethod(result);
  };

  return (
    <div className="row justify-content-center">
      <form onSubmit={handleSubmit}>
        <CardSection />
        <button 
          className="btn btn-primary float-right" 
          type="submit" 
          disabled={!stripe}
        >
          Subscribe
        </button>
      </form>
    </div>
  );
}